module.exports = __webpack_public_path__ + "assets/img/mask-bg3.b7ae49ea.png";